import $api from "@/frontend/shared/api/axios";

export async function removeTagFromCompany({ tagIds, companyId }: { tagIds: number[]; companyId: number }) {
  return $api.delete(`/portfolio-companies/${companyId}/tags`, { data: { tagIds } });
}
